import React, { Suspense, useEffect, useState } from 'react'
import { GridColDef } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import NotificationAPI from 'api/faber/NotificationAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'
import NormalText from 'common/Typography/NormalText'
import OrbitSession from 'hooks/useCookies'

import PushNotificationForm from './PushNotification/PushNotificationForm'

function CampaignView() {
  const faberToken = OrbitSession.get('faberToken')

  interface GridRowDataType {
    userId: string
    executedAt: string
    numUsers: number
    notificationTitle: string
    notificationBody: string
  }

  const columns: GridColDef[] = [
    {
      field: 'userId',
      headerName: 'User ID',
      width: 200
    },
    { field: 'numUsers', headerName: 'Number of Users', width: 25 },
    {
      field: 'notificationTitle',
      headerName: 'Notification Title',
      width: 120
    },
    { field: 'notificationBody', headerName: 'Notification Body', width: 50 },
    { field: 'executedAt', headerName: 'Executed At', width: 150 }
  ]

  const [pushNotificationHistory, setPushNotificationHistory] = useState<
    GridRowDataType[]
  >([])

  const { data: pushNotificationLogs } = useQuery(
    ['pushNotificationLogs'],
    async () => {
      return NotificationAPI.getPushNotificationHistory(faberToken)
    }
  )

  useEffect(() => {
    if (pushNotificationLogs?.data) {
      const pushNotificationHistory = pushNotificationLogs.data.map((log) => {
        return {
          userId: log.userId,
          executedAt: log.executedAt,
          numUsers: log.extraFields?.allUsersSent?.length,
          notificationTitle: log.extraFields?.notificationContent?.body,
          notificationBody: log.extraFields?.notificationContent?.title
        }
      })
      setPushNotificationHistory(pushNotificationHistory)
    }
  }, [pushNotificationLogs])

  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <PageLayoutV2 header='Manage Campaign'>
        <ColorBox sx={{ minWidth: '1000px' }}>
          <NormalText isBold>Send push notification (app)</NormalText>
          <PushNotificationForm />
        </ColorBox>
      </PageLayoutV2>
      <ColorBox sx={{ minWidth: '1000px' }}>
        <NormalText isBold>Push notification history</NormalText>
        <MUIDataGrid
          columns={columns}
          rows={pushNotificationHistory}
          getRowId={(row: GridRowDataType) => `${row.userId}_${row.executedAt}`}
        />
      </ColorBox>
    </Suspense>
  )
}

export default CampaignView
